import { useQuery, useMutation } from "@tanstack/react-query";
import clientPortalAxiosInstance from "../../common/utilities/axios/clientPortalAxiosInstance";
import sleep from "sleep-promise";


// get languages list by client account id
export const useGetReportResourceById = ({ reportResourceId }) => {
  return useQuery({
    queryKey: ["getReportResourceById", `${reportResourceId}`],
    queryFn: () => {
      return clientPortalAxiosInstance
        .get(
          `Reports-Resources/report/getAllAdminReportResource/${reportResourceId}`
        )
        .then((res) => {
          return res.data;
        });
    },
    // The query will not execute until the Id exists
    enabled: !!reportResourceId,
  });
};


/**Mutations */
export const useViewAllAdminReportResourceListMutation = () => {
  return useMutation({
    mutationFn: ({ loggedInUserId, roleId, isEnterpriseAdmin }) => {
      return clientPortalAxiosInstance.post(`/Reports-Resources/report/rolebasedGetAllAdminReportResource`, {
        "LoggedInUserId": loggedInUserId || "",
        "RoleId": roleId || "",
        "IsEnterpriseAdmin": isEnterpriseAdmin
      })
    },
  })
}
// api for create client user
export const useCreateReportResourceMutation = () => {
  return useMutation({
    mutationFn: ({ body }) => {
      return clientPortalAxiosInstance.post(
        `/Reports-Resources/report/createReportResource`,
        body
      );
    },
  });
};

// api for delete admin msg
export const useDeleteReportResourceByIdMutation = () => {
  return useMutation({
    mutationFn: ({ isDeleteMode, Id }) => {
      return clientPortalAxiosInstance.delete(
        `/Reports-Resources/report/deleteReportResource/${Id}`, {
        data: {
          IsDeleteMode: isDeleteMode
        }
      }
      );
    },
  });
};

/**
 * If you use PUT to upload file then you may use application/octet-stream as Content-Type. If you upload into Amazon S3 storage using multipart/formdata as Content-Type it will make your files (images, pdfs, documents) into text files with http header added on top. This will damage the content of the uploaded file. So use application/octet-stream when uploading binary files with PUT methods.
 */
export const useUploadClientSpecificReportFileMutation = () => {

  return useMutation({
    mutationFn: ({ file }) => {
      /**file is single file and not array of files */

      const formData = new FormData();
      formData.append('file', file)

      return clientPortalAxiosInstance.post(`/Reports-Resources/report/uploadReportResourceDocument`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
    },
  })
}
